import {baseAxios} from '@mc/axios-api';

import * as Api from './gen/api';
export * from './gen/configuration';
export * from './gen/model';

// Aktuálně už nepotřebujeme context path, v novějším axios už to chodí i bez toho
const baseURL = '';

// const baseAxios = axios;
// baseAxios.interceptors.response.use(null, standardErrorInterceptor);

const MapioApi = new Api.MapioControllerApi(undefined, baseURL, baseAxios);
const AtributyApi = new Api.AttributesControllerApi(undefined, baseURL, baseAxios);
const AkceApi = new Api.ActionsControllerApi(undefined, baseURL, baseAxios);
const LayerSettingsApi = new Api.LayerSettingsControllerApi(undefined, baseURL, baseAxios);
const RightsApi = new Api.RightsControllerApi(undefined, baseURL, baseAxios);
const DocumentApi = new Api.DocumentControllerApi(undefined, baseURL, baseAxios);
const PrintApi = new Api.PrintControllerApi(undefined, baseURL, baseAxios);
const ConfigApi = new Api.ConfigControllerApi(undefined, baseURL, baseAxios);
const UserLayersApi = new Api.UserLayersControllerApi(undefined, baseURL, baseAxios);
const ExportImportApi = new Api.ExportImportControllerApi(undefined, baseURL, baseAxios);
const PublicExportApi = new Api.PublicExportControllerApi(undefined, baseURL, baseAxios);
const ServicesApi = new Api.ServicesControllerApi(undefined, baseURL, baseAxios);
const ParovaniApi = new Api.ParovaniControllerApi(undefined, baseURL, baseAxios);
const ShpImportApi = new Api.ShpImportControllerApi(undefined, baseURL, baseAxios);
const JsonImportApi = new Api.JsonImportControllerApi(undefined, baseURL, baseAxios);
const ExternalLinksApi = new Api.ExternalLinksControllerApi(undefined, baseURL, baseAxios);
const GmlExportApi = new Api.GmlExportControllerApi(undefined, baseURL, baseAxios);
const MapioDtmApi = new Api.MapioDtmControllerApi(undefined, baseURL, baseAxios);
const DataGridApi = new Api.DataGridControllerApi(undefined, baseURL, baseAxios);
const SearchFilterApi = new Api.SearchFilterControllerApi(undefined, baseURL, baseAxios);

export {
    MapioApi,
    UserLayersApi,
    AtributyApi,
    AkceApi,
    LayerSettingsApi,
    RightsApi,
    DocumentApi,
    PrintApi,
    ConfigApi,
    PublicExportApi,
    ExportImportApi,
    ServicesApi,
    ParovaniApi,
    ShpImportApi,
    JsonImportApi,
    ExternalLinksApi,
    GmlExportApi,
    MapioDtmApi,
    DataGridApi,
    SearchFilterApi,
};
